/* eslint-disable no-restricted-globals */
import WebWorkerServer from './WebWokerServer';
import LimitMap from './LimitMap';
import Logs from './Logs';

const server = new WebWorkerServer(self as unknown as Worker);
const logsInstanceMap = new LimitMap({ limit: 8 });
server.on('highlight-log', (ctx, { id, string }) => {
  if (!logsInstanceMap.has(id)) {
    logsInstanceMap.set(id, new Logs({ id, string }));
  }
  const instance = logsInstanceMap.get(id) as Logs;
  ctx.send('highlight-log-success', {
    id,
    logs: instance?.getArrayData(),
  });
});
server.on('search-log', (ctx, { id, searchId, keyword = '', hlIndex, string = '', options }) => {
  if (!keyword) {
    ctx.send('search-log-success', {
      id,
      searchId,
      searcherResult: {
        map: {},
        count: 0,
        markedKey: 0,
      },
    });
    return;
  }
  if (!logsInstanceMap.has(id)) {
    logsInstanceMap.set(id, new Logs({ id, string }));
  }
  const instance = logsInstanceMap.get(id) as Logs;
  if (instance) {
    ctx.send('search-log-success', {
      id,
      searchId,
      searcherResult: instance.mark(keyword, hlIndex, options) || {
        map: {},
        count: 0,
        markedKey: 0,
      },
    });
  }
});
